import { useQuery } from '@tanstack/react-query';
import { ReleaseBuild } from '@internal/backstage-plugin-bidone-backend';
import { UseQueryCustomResult } from '../types';
import { useAuthedFetch } from './useAuthedFetch';

export const useReleaseBuilds = (
  release: string | null,
): UseQueryCustomResult<ReleaseBuild[]> => {
  const authedFetch = useAuthedFetch();
  return useQuery({
    queryKey: ['builds', release],
    queryFn: async () =>
      authedFetch(
        `/releases/${encodeURIComponent(release as string)}/builds`,
      ),
    enabled: !!release,
  });
};
